import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const auditor = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.AUDITOR_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.AUDITOR_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.AUDITOR_ERROR:
      draft[action.key] = false;
      draft.error = action.error;
      return draft;
    case ACTIONS.AUDITOR_SUGGESTION_REQUEST:
      draft.suggestionLoading = true;
      return draft;
    case ACTIONS.AUDITOR_SUGGESTION_SUCCESS:
      draft.suggestionLoading = false;
      draft.error = null;
      return draft;
    case ACTIONS.AUDITOR_SUGGESTION_ERROR:
      draft.suggestionLoading = false;
      draft.error = action.error;
      return draft;
    case ACTIONS.GET_AUDITOR_BY_ID_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    default:
      return draft;
  }
});

export default auditor;
